import type { ReactNode } from "react";
import { Sidebar } from "./Sidebar";

type Props = { children: ReactNode };

export function Layout({ children }: Props) {
  return (
    <div style={{ display: "flex", minHeight: "100vh" }}>
      <Sidebar />
      <main style={{
        flex: 1,
        marginLeft: 220,
        padding: "32px 28px",
        paddingBottom: 80,
        maxWidth: "100%",
        overflowX: "hidden",
      }} className="layout-main">
        {children}
      </main>

      <style>{`
        @media (max-width: 768px) {
          .sidebar-desktop { display: none !important; }
          .layout-main { margin-left: 0 !important; padding: 20px 16px 80px !important; }
        }
        @media (min-width: 769px) {
          .sidebar-mobile { display: none !important; }
        }
      `}</style>
    </div>
  );
}
